import { useEffect, useState } from 'react';
import { ProfiledDoctorsList } from '@/widgets/DoctorProfileList/ui';
import { useHttp } from '@/shared/api/provider';
import type { IPagination } from '@/entities/common/types/api';
import type { IBaseDoctor } from '@/entities/doctor/model/types';
import type { Skill } from '@/entities/skill/model/types';
interface MedcenterDoctorsProps {
  initialDoctors: IBaseDoctor[];
  selectedSkill: Skill | null;
  medcenterAlias: string;
}
interface DoctorsResponse {
  data: IBaseDoctor[];
  pagination: IPagination;
}
export const MedcenterDoctors: React.FC<MedcenterDoctorsProps> = ({
  initialDoctors,
  selectedSkill,
  medcenterAlias
}) => {
  const http = useHttp();
  const [page, setPage] = useState(1);
  const [doctors, setDoctors] = useState<IBaseDoctor[]>(initialDoctors || []);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const updateDoctorsState = (response: DoctorsResponse, nextPage: number, shouldReplace = false) => {
    setDoctors(prevDoctors => shouldReplace ? response.data : [...prevDoctors, ...response.data]);
    setHasMore(response.pagination.hasNextPage);
    setPage(nextPage);
  };
  const fetchDoctorsRequest = async (pageNumber: number) => {
    const response = await http.medcenter.getDoctorsInMedcenter(medcenterAlias, {
      page: pageNumber,
      skillId: selectedSkill?.id
    });
    return response;
  };
  useEffect(() => {
    const fetchDoctors = async () => {
      setIsLoading(true);
      try {
        const response = await fetchDoctorsRequest(1);
        updateDoctorsState(response, 1, true);
      } catch (error) {
        console.error('Error fetching doctors:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDoctors();
  }, [selectedSkill, medcenterAlias]);
  const handleLoadMore = async () => {
    if (!hasMore || isLoading) return;
    try {
      setIsLoading(true);
      const nextPage = page + 1;
      const response = await fetchDoctorsRequest(nextPage);
      updateDoctorsState(response, nextPage);
    } finally {
      setIsLoading(false);
    }
  };
  return <ProfiledDoctorsList doctors={doctors} visibleSkill={selectedSkill} onLoadMore={handleLoadMore} hasMore={hasMore} isLoading={isLoading} data-sentry-element="ProfiledDoctorsList" data-sentry-component="MedcenterDoctors" data-sentry-source-file="MedcenterDoctors.tsx" />;
};